import React from 'react';

const BackgroundLines = () => (
  <div className="bglines">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
);

export default BackgroundLines;
